// extracted by mini-css-extract-plugin
export default {"Datenschutz":"Datenschutz_Datenschutz__qJEN+","iframe":"Datenschutz_iframe__W5yq3"};